import HardBreak from "@tiptap/extension-hard-break"

export const HardBreakContentExtension = HardBreak.extend({
  // Render HardBreak as <br /> instead of an indented line.
  // This works more reliably for sequential HardBreaks and HardBreaks
  // at the end of a paragraph.
  // "Normal" hard breaks (indented lines, plus other forms of BR) still parse properly.
  markdownTokenizer: {
    name: "br",
    level: "inline",
    start: (src) => src.search(/<br\s*\/?>/i),
    tokenize(src) {
      const match = /^<br\s*\/?>/i.exec(src)
      return match ? { type: "br", raw: match[0] } : undefined
    },
  },
  renderMarkdown: () => "<br />",
})
